export default __webpack_public_path__ + "static/media/semantika_logo.6fc3df82.png";